import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
export default {
  props: {
    labelWidth: String,
    label: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    vstyle: String,
    size: {
      type: String,
      default: 'mini'
    },
    prop: String,
    rules: Array,
    miniLineHeight: {},
    editType: String,
    clearable: {
      default: true
    },
    inputWidth: {}
  },
  data: function data() {
    return {
      lookclass: '',
      myrules: [{
        min: 0,
        message: '',
        trigger: 'blur'
      }],
      parentCmForm: undefined
    };
  },
  mounted: function mounted() {
    this.setrules();
    this.getparentFrom();
  },
  computed: {
    myeditType: function myeditType() {
      if (this.parentCmForm === undefined) {
        return this.editType || 'edit';
      } else {
        return this.editType || this.parentCmForm.editType || 'edit';
      }
    },
    myholder: function myholder() {
      return this.placeholder || (this.label ? '请输入' + (this.label.split(':')[0] || '') : '');
    },
    myclass: function myclass() {
      var _class = 'v_input_fullheight';
      if (this.parentCmForm !== undefined) {
        _class = (this.miniLineHeight || this.parentCmForm.miniLineHeight) !== undefined ? 'v_input_miniheight' : 'v_input_fullheight';
      } else {
        _class = this.miniLineHeight !== undefined ? 'v_input_miniheight' : 'v_input_fullheight';
      }
      if (this.myeditType === 'look') {
        _class += ' v_input_miniheight v_input_look';
      }
      if (this.label === undefined) {
        _class += ' v_input_no_lable';
      }
      return _class;
    },
    myinputWidth: function myinputWidth() {
      if (this.parentCmForm === undefined) {
        return 'width:' + (this.inputWidth || '100%');
      } else {
        return 'width:' + (this.inputWidth || this.parentCmForm.inputWidth || '100%');
      }
    }
  },
  methods: {
    setrules: function setrules() {
      var _this = this;
      if (this.rules !== undefined) {
        this.myrules = this.rules;
        this.myrules.forEach(function (item) {
          if (item.message === undefined) {
            item.message = '请填写' + (_this.label || '');
            if (item.trigger === undefined) {
              item.trigger = 'blur';
            } else {
              item.trigger = 'change';
            }
          }
        });
      }
    },
    getparentFrom: function getparentFrom() {
      var nowParent = this.$parent;
      for (var i = 0; i < 10; i++) {
        if (nowParent === undefined) {
          break;
        }
        if (nowParent.cm_name !== 'cmForm') {
          nowParent = nowParent.$parent;
        }
      }
      this.parentCmForm = nowParent;
    }
  },
  watch: {
    'rules': function rules(val, oldValue) {
      this.setrules();
    }
  }
};